module.exports = __webpack_public_path__ + "img/112.a9189dc0.jpg";